<h1>
    <strong>{{ appName }}</strong> (mode <strong>{{ production ? 'production' : 'développement' }}</strong>) - v{{ appVersion }}
    @if (gitVersion != '') { / commit : {{ gitVersion }} }
</h1>

@if (sessionInfo(); as info) {
  <section class="session-bloc">
    <h2>Session</h2>
    <div class="session-lignes">
      <div class="session-ligne">
        <span class="session-libelle">Utilisateur</span>
        <span class="session-valeur session-texte">{{ info.prenom }} {{ info.nom }}</span>
      </div>
      <div class="session-ligne">
        <span class="session-libelle">Identifiant</span>
        <span class="session-valeur session-texte">{{ info.username }}</span>
      </div>
      <div class="session-ligne">
        <span class="session-libelle">Rôles</span>
        <span class="session-valeur session-texte">{{ info.roles.join(', ') }}</span>
      </div>
      <div class="session-ligne">
        <span class="session-libelle">Connecté</span>
        <span class="session-valeur session-texte">{{ info.logged ? 'Oui' : 'Non' }}</span>
      </div>
      <hr class="session-sep" />
      <div class="session-ligne">
        <span class="session-libelle">Émission du token</span>
        <span class="session-valeur session-texte">{{ info.iatDate }}</span>
      </div>
      <div class="session-ligne">
        <span class="session-libelle">Expiration du token</span>
        <span class="session-valeur session-texte">{{ info.expDate }}</span>
      </div>
      <hr class="session-sep" />
      <div class="session-ligne">
        <span class="session-libelle">Rafraîchissement automatique dans</span>
        <span class="session-valeur" [class.session-imminent]="info.avantRefresh < 60">{{ formatDuree(info.avantRefresh) }}</span>
      </div>
      <div class="session-ligne">
        <span class="session-libelle">Expiration dans</span>
        <span class="session-valeur" [class.session-imminent]="info.avantExpiration < 120">{{ formatDuree(info.avantExpiration) }}</span>
      </div>
    </div>
  </section>
}
